import { type FetchPledgeUserMeActivitySummaryData, minutesToMs, pledgeApi } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

export const useUserPledgeActivitySummaryQuery = () => {
	return useQuery({
		enabled: true,
		queryFn: async () => {
			return (
				await pledgeApi
			).fetchPledgeUserMeActivitySummary() as Promise<FetchPledgeUserMeActivitySummaryData>;
		},
		queryKey: ['user-pledge-activity-summary'],
		select: res => res.data,
		staleTime: minutesToMs(1)
	});
};
